import { createPinia } from 'pinia'
import { createSentryPiniaPlugin } from '@sentry/vue'

const pinia = createPinia()
pinia.use(
  createSentryPiniaPlugin({
    addBreadcrumbs: false,
    attachPiniaState: false,
    stateTransformer: (state) => {
      const transformedState = {
        ...state,
        userAuth: {
          ...(state?.userAuth ?? {}),
          token: '*******',
        },
      }
      return transformedState
    },
  })
)

export default pinia
